export default __webpack_public_path__ + "static/media/Picture4.79827f7f.png";